import React, { FC, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks/useStores';
import useWindowSize from 'hooks/useWindowSize';
import Popup from 'ati-ui-react/components/Popup';
import getEnvironDomain from 'utils/getEnvironDomain';
import decline from 'utils/decline';

const CheckTransportPopup: FC = observer(() => {
  const [width] = useWindowSize();

  const {
    checksStore,
    checksStore: {
      checkPopupParams,
      checkTransportUrlStatus,

      resetCheckPopupParams,
      checkTransport,
    },
  } = useStores();

  useEffect(() => {
    if (width <= 512) {
      resetCheckPopupParams();
    }
  }, [width]);

  if (!checkPopupParams.check_id) return null;

  const redirect = async () => {
    await checkTransport(
      checkPopupParams.advert_id,
      checkPopupParams.check_id,
      checkPopupParams.transport_position,
    );

    if (checksStore.checkTransportUrl) {
      window.open(
        `https://${getEnvironDomain()}/verification/results/${checksStore.checkTransportUrl}/`,
        '_self',
      );
      resetCheckPopupParams();
    }
  };

  const declineAt = decline(checkPopupParams.amount, ['атис', 'атиса', 'атисов']);
  const declineCheck = decline(checkPopupParams.limit_balance, [
    'проверка',
    'проверки',
    'проверок',
  ]);

  return (
    <Popup
      title={checkPopupParams.description}
      className="popup-check"
      isPrimaryActionLoading={checkTransportUrlStatus.isRequest}
      primaryAction={{
        name: 'Проверить ТС',
        action: redirect,
      }}
      alternateAction={{
        name: 'Отмена',
        action: resetCheckPopupParams,
      }}
      onClose={resetCheckPopupParams}
      closeOnOverlayClick
      whiteActionArea
      small
    >
      {!!checkPopupParams.limit_balance && checkPopupParams.limit_balance > 0
        ? `${checkPopupParams.limit_balance} ${declineCheck} бесплатно, затем по ${checkPopupParams.amount} ${declineAt}`
        : `За проверку с вас будет списано ${checkPopupParams.amount} ${declineAt}`}
    </Popup>
  );
});

export default CheckTransportPopup;
